// extracted by mini-css-extract-plugin
export default {"logoSvg":"logo_home_logoSvg__lxMCe"};